import utils from '@/utils'

/**
 * 数値
 */
export default (val, msg) => {
  if (utils.string.isEmpty(val)) {
    return true
  }
  if (/^\d*$/.test(val)) {
    return true
  }

  return msg
}
